export interface SingleModelMergerField<T> {
  key: string;
  label: string;
  selectable: boolean;
  /**
   * Allows the consumer of this component to run arbitrary code when a specific field was selected.
   * This is useful when we want to change another field when a master field is changed.
   */
  onChange?: (event: { candidate: T; selectAll?: () => void }) => void;
}

export interface FieldsetModelMergerField<T> {
  key: string;
  label: string;
  selectable: boolean;
  fields: { key: string; label: string }[];
  /**
   * Allows the consumer of this component to run arbitrary code when a specific field was selected.
   * This is useful when we want to change another field when a master field is changed.
   */
  onChange?: (event: { candidate: T; selectAll?: () => void }) => void;
}

export type ModelMergerField<T> = SingleModelMergerField<T> | FieldsetModelMergerField<T>;

export function isSingleModelMergerField<T extends object>(value: unknown): value is SingleModelMergerField<T> {
  if (value == null) {
    return false;
  }

  return typeof value === 'object' && !value.hasOwnProperty('fields');
}

export function isFieldsetModelMergerField<T extends object>(value: unknown): value is FieldsetModelMergerField<T> {
  if (value == null) {
    return false;
  }

  return typeof value === 'object' && value.hasOwnProperty('fields') && Array.isArray(value['fields']);
}
